import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import request from '../../services/Request';
import MaterialTable from 'material-table';
import BackButton from '../items/buttons/BackButton';
import LoadingIcon from '../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import AddPlan from './AddPlan';
import { userLimits } from '../dashboard/uitls/userLimits';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ProductPositionModal from './ArrangeProduct/ProductPositionModal';
import { CloudDownload, Add, Save } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import { ExportToCsv } from 'export-to-csv';
import { useHistory } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Modal, Form, Card, Tabs, Tab } from 'react-bootstrap';

const saveFridgeURL = `/machines/updateFridge`;
const getAllProdURL = `/products/`; // Endpoint to get all products

export default function AddFridgeToMachine(props) {
  const history = useHistory();
  const { filterd, setFiltered } = useContext(UserContext);

  const { id, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    '',
    'edit_machine'
  );
  const user = JSON.parse(localStorage.getItem('user'));
  const additionPriceOn = user?.features?.additionPrice;
  const theme = user?.theme;
  let lasturl = window.location.href.split('/').pop();
  const machineID = lasturl !== 'all' ? lasturl : null;

  const [loading, setLoading] = useState(false);
  const [reflesh, setReflesh] = useState(false);
  const [title, setTitle] = useState('');
  const tableRef = React.useRef();

  // Initialize fridges state with empty arrays first
  const [fridges, setFridges] = useState([
    {
      name: 'Fridge 1',
      type: 'fridge',
      products: [],
    },
    {
      name: 'Fridge/Shelf 2',
      type: 'fridge',
      products: [],
    },
  ]);

  const [activeTab, setActiveTab] = useState(0);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const downloadProductCsv = async (products) => {
    // console.log('products', products);
    let newArray = [];
    products.forEach((element) => {
      const newObj = {};
      newObj.name = element.id.name;
      newObj.upc = element.id.upc;
      newObj.price = element.id.price;
      // newObj.modified_price = element.nPrice ? element.nPrice : '';
      newObj.current_stock = element.id.current_stock || 0;
      newArray.push(newObj);
    });

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Machine_Products',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      filename: 'Machine_Products',
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(newArray);
  };

  // Check if filterd is empty and redirect if necessary
  useEffect(() => {
    if (!filterd || filterd.length === 0) {
      console.log('No machines selected, redirecting to viewMyMachines');
      history.push('/dashboard/viewMyMachines');
      return;
    }
  }, [filterd, machineID, history]);

  // Initialize fridges with data from filterd and availableProducts
  useEffect(() => {
    if (filterd && filterd.length > 0 && filterd[0] && availableProducts.length > 0) {
      const machineData = filterd[0];

      // Function to map product IDs to full product details
      const mapFridgeProductsToFullDetails = (fridgeProductIds) => {
        if (!fridgeProductIds || !Array.isArray(fridgeProductIds)) return [];

        return fridgeProductIds
          .map((fridgeProduct) => {
            // fridgeProduct could be just an ID string, or an object with ID and other properties
            const productId =
              typeof fridgeProduct === 'string'
                ? fridgeProduct
                : fridgeProduct._id || fridgeProduct.id || fridgeProduct;

            // Find the full product details from availableProducts
            const fullProduct = availableProducts.find(
              (product) => product.id._id === productId || product.id.id === productId
            );

            if (fullProduct) {
              return {
                id: {
                  ...fullProduct.id,
                  name:
                    fullProduct.id.name || (fullProduct.id.name?.en ? fullProduct.id.name.en : ''),
                  nPrice: fridgeProduct.nPrice || null,
                  current_stock: fridgeProduct.current_stock,
                },
                nPrice: fridgeProduct.nPrice || null, // Preserve any existing modified price
              };
            } else {
              // If product not found in availableProducts, create a placeholder
              console.warn(`Product with ID ${productId} not found in available products`);
              return {
                id: {
                  _id: productId,
                  name: 'Product not found',
                  price: 0,
                  upc: '',
                  productPictures: [],
                },
                nPrice: null,
              };
            }
          })
          .filter(Boolean); // Remove any null/undefined entries
      };

      setFridges([
        {
          name: 'Fridge 1',
          type: 'fridge',
          products: mapFridgeProductsToFullDetails(machineData.product_fridge_1),
        },
        {
          name: 'Fridge/Shelf 2',
          type: 'fridge',
          products: mapFridgeProductsToFullDetails(machineData.product_fridge_2),
        },
      ]);

      // Set title
      setTitle(machineData.name || '');
    }
  }, [filterd, availableProducts]); // Run when filterd OR availableProducts changes

  // useEffect(() => {
  //   console.log('fridges', fridges);
  // }, [fridges]);

  useEffect(() => {
    // Get all available products
    const getAllProducts = async () => {
      try {
        const response = await request({
          method: 'get',
          url: getAllProdURL + id + '/plano',
        });
        if (response && response.data) {
          const newData = response.data.map((e) => ({
            id: {
              ...e,
              name: e.name.en,
            },
          }));
          // console.log('newData', newData);
          setAvailableProducts(newData);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    if (id) {
      getAllProducts();
    }

    setLoading(true);

    return () => {
      setLoading(false);
      setAvailableProducts([]);
    };
  }, [reflesh, id]);

  const updateProd = async (id, price) => {
    let newArray = Object.values(id);
    newArray = newArray.map((e) => e.newData);

    // Update products in the current fridge too
    const updatedFridges = [...fridges];
    if (updatedFridges[activeTab] && updatedFridges[activeTab].products) {
      newArray.forEach((changes) => {
        updatedFridges[activeTab].products.forEach((element) => {
          if (element.id._id === changes.id._id) {
            element.id.nPrice = changes.nPrice;
            element.nPrice = changes.nPrice;
          }
        });
      });
      setFridges(updatedFridges);
    }
  };

  // Handler for saving the current fridge products
  const handleSaveFridge = () => {
    Swal.fire({
      title: 'Save Changes',
      text: 'Are you sure you want to save the changes to this fridge?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!',
    }).then((result) => {
      if (result.isConfirmed) {
        let products = fridges[activeTab].products.map((pd) => pd.id);
        if (products?.length > 0) {
          products = products.map((item) => ({
            ...item,
            id: item._id,
          }));
        }

        console.log('ActiveFridge', products);
        console.log('machineID', machineID);
        request({
          method: 'post',
          url: saveFridgeURL,
          data: {
            machineID: machineID,
            products: products,
            activeTab: activeTab,
          },
        })
          .then((response) => {
            if (response.data) {
            }
          })
          .catch((err) => console.log(err))
          .finally(() => {});

        // For now, we'll just show a success message
        Swal.fire('Saved!', 'Your fridge configuration has been saved.', 'success');
      }
    });
  };

  // Handler for clearing all products from the current fridge
  const handleClearFridge = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, clear it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedFridges = [...fridges];
        // Clear products but keep the fridge
        updatedFridges[index].products = [];
        setFridges(updatedFridges);

        Swal.fire('Cleared!', 'All products have been removed from this fridge.', 'success');
      }
    });
  };

  // Handler for adding products to the current fridge
  const handleAddProducts = () => {
    if (selectedProducts.length === 0) {
      Swal.fire('Error', 'Please select at least one product', 'error');
      return;
    }

    const updatedFridges = [...fridges];
    const currentFridge = updatedFridges[activeTab];

    // Add selected products to current fridge
    selectedProducts.forEach((product) => {
      // Check if product already exists in the fridge
      const existingIndex = currentFridge.products.findIndex((p) => p.id._id === product.id._id);
      if (existingIndex === -1) {
        currentFridge.products.push(product);
      }
    });

    setFridges(updatedFridges);
    setSelectedProducts([]);
    setShowAddProductModal(false);
  };

  // Handler for selecting products in modal
  const handleProductSelection = (product) => {
    const selectedIndex = selectedProducts.findIndex((p) => p.id._id === product.id._id);

    if (selectedIndex > -1) {
      // Remove from selection
      const updatedSelection = [...selectedProducts];
      updatedSelection.splice(selectedIndex, 1);
      setSelectedProducts(updatedSelection);
    } else {
      // Add to selection
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  // Reset price for current fridge
  const handleResetPrice = () => {
    Swal.fire({
      title: 'Are you sure to reset all prices?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reset it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const updatedFridges = [...fridges];
        const currentFridge = updatedFridges[activeTab];

        // Reset prices for all products in current fridge
        currentFridge.products.forEach((product) => {
          product.nPrice = null;
        });

        setFridges(updatedFridges);

        Swal.fire('Price reset!', 'All products have been reset to default price.', 'success');
      }
    });
  };

  // Handler for removing a product from the current fridge
  const handleRemoveProduct = (productId) => {
    const updatedFridges = [...fridges];
    const currentFridge = updatedFridges[activeTab];

    const productIndex = currentFridge.products.findIndex((p) => p.id._id === productId);
    if (productIndex > -1) {
      currentFridge.products.splice(productIndex, 1);
      setFridges(updatedFridges);
    }
  };

  const columns = [
    {
      title: 'Picture',
      field: 'id.productPicture',
      editable: 'never',
      render: (rowData) => (
        <img
          src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.id.productPictures[0]}/${id}`}
          style={{ height: 50 }}
        />
      ),
    },
    { title: 'Product Name', editable: 'never', field: 'id.name' },
    { title: 'UPC/SKU', editable: 'never', field: 'id.upc' },
    // {
    //   title: 'Price',
    //   field: 'nPrice',
    //   type: 'numeric',
    //   render: (rowData) => (rowData.nPrice ? `$${rowData.nPrice}` : `$${rowData.id.price}`),
    //   editable: additionPriceOn ? 'never' : 'always',
    // },
    {
      title: 'Current Stock',
      field: 'id.current_stock',
      editable: 'never',
      render: (rowData) => rowData.id.current_stock || 0,
    },
    {
      title: 'Actions',
      field: 'actions',
      editable: 'never',
      render: (rowData) => (
        <Button variant="danger" size="sm" onClick={() => handleRemoveProduct(rowData.id._id)}>
          <DeleteIcon fontSize="small" />
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px',
          marginBottom: '20px',
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: '90%',
        }}
      >
        <h4>Update Fridge for the Machine: {title}</h4>
      </div>

      {!loading ? (
        <LoadingIcon />
      ) : (
        <div style={{ maxWidth: '100%', margin: '0 auto' }}>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(parseInt(k))}
            id="fridge-tabs"
            className="mb-3 ml-3"
          >
            {fridges.map((fridge, index) => (
              <Tab
                key={index}
                eventKey={index}
                title={
                  <div className="d-flex align-items-center">
                    <span>{fridge.name}</span>
                    <Button
                      variant="link"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleClearFridge(index);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </Button>
                  </div>
                }
              >
                <Card>
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5>{fridge.name}</h5>
                      <div>
                        <Button
                          variant="success"
                          className="mr-2"
                          onClick={() => setShowAddProductModal(true)}
                        >
                          <Add fontSize="small" className="mr-2" /> Add Products
                        </Button>

                        <Button variant="primary" className="mr-2" onClick={handleSaveFridge}>
                          <Save fontSize="small" className="mr-2" /> Save Changes
                        </Button>

                        {/* {!additionPriceOn && (
                          <Button variant="warning" className="mr-2" onClick={handleResetPrice}>
                            <RestartAltIcon fontSize="small" className="mr-2" /> Reset Prices
                          </Button>
                        )} */}

                        <Button
                          variant="info"
                          onClick={() => downloadProductCsv(fridges[activeTab].products)}
                        >
                          <CloudDownload fontSize="small" className="mr-2" /> Export CSV
                        </Button>
                      </div>
                    </div>

                    <MaterialTable
                      tableRef={tableRef}
                      columns={columns}
                      data={fridge.products}
                      title=""
                      // editable={
                      //   access && {
                      //     onBulkUpdate: (changes) =>
                      //       new Promise((resolve, reject) => {
                      //         setTimeout(() => {
                      //           Swal.fire({
                      //             text: `Please click 'Save' button to actually save the changes`,
                      //             icon: 'info',
                      //           });
                      //           updateProd(changes);
                      //           resolve();
                      //         }, 1000);
                      //       }),
                      //   }
                      // }
                      options={{
                        pageSizeOptions: [10, 20, 50],
                        pageSize: 10,
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: theme === 'dark' ? '#333' : '#f5f5f5',
                          color: theme === 'dark' ? '#fff' : '#000',
                        },
                        rowStyle: (rowData) => ({
                          backgroundColor: rowData.hide ? '#ffcccc' : '',
                        }),
                      }}
                    />
                  </Card.Body>
                </Card>
              </Tab>
            ))}
          </Tabs>
          <BackButton marginTop={-8.2} marginRight={43} />
        </div>
      )}

      {/* Add Products Modal */}
      <Modal
        show={showAddProductModal}
        onHide={() => {
          setShowAddProductModal(false);
          setSelectedProducts([]);
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Products to {fridges[activeTab]?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div className="mb-3">
            <Form.Control
              type="text"
              placeholder="Search products..."
              onChange={(e) => {
                // Filter products based on search term
                // Implementation would depend on your backend structure
              }}
            />
          </div>
          <div className="row">
            {availableProducts.map((product, index) => {
              const isSelected = selectedProducts.some((p) => p.id._id === product.id._id);
              return (
                <div key={index} className="col-md-6 mb-3">
                  <Card
                    className={`h-100 ${isSelected ? 'border-primary' : ''}`}
                    onClick={() => handleProductSelection(product)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Card.Body className="d-flex">
                      {product?.id?.productPictures && product?.id?.productPictures[0] && (
                        <div className="mr-3">
                          <img
                            src={`${process.env.REACT_APP_SERVER_API}/pictures/${product.id.productPictures[0]}/${id}`}
                            style={{ width: 100, height: 100, objectFit: 'contain' }}
                            alt={product.id.name}
                          />
                        </div>
                      )}
                      <div>
                        <Card.Title>{product.id.name}</Card.Title>
                        <Card.Text>
                          SKU: {product.id.upc}
                          <br />
                          Price: ${product.id.price}
                          <br />
                          {/* Category: {product.category} */}
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <div>Selected Products: {selectedProducts.length}</div>
            <div>
              <Button
                variant="secondary"
                className="mr-2"
                onClick={() => {
                  setShowAddProductModal(false);
                  setSelectedProducts([]);
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleAddProducts}>
                Add Selected Products
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
